module.exports = __webpack_public_path__ + "img/THEOS_LOGOCHROME_60X70.3629354a.gif";